
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import Evidence from '@/data/Evidence'
import { Ghost } from '@/data/Ghosts'

export default class Home extends Vue {
  @Prop(Array) readonly evidence!: string[];
  @Prop(Object) readonly ghosts!: Ghost[]

  round(num: number, decimals: number) {
    // TypeScript shenanigans...
    const numberToRound: any = num + 'e+' + decimals
    const numberToSubtract: any = 'e-' + decimals
    return +(Math.round(numberToRound) + numberToSubtract)
  }

  get probabilities() {
    const evidence = Evidence.filter(evidence => !this.evidence.includes(evidence))
    const evidenceCount: number[] = Array(Evidence.length).fill(0)

    // Count amount of ghosts that can have a certain type of evidence
    for (let i = 0; i < evidence.length; i++) {
      for (let j = 0; j < this.ghosts.length; j++) {
        // Increment evidence count by one.
        if (this.ghosts[j].evidence.includes(evidence[i])) {
          evidenceCount[i]++
        }
      }
    }

    const probabilities: { [key: string]: number } = {}
    const totalCount = evidenceCount.reduce((a, b) => a + b, 0)

    if (totalCount === 0) {
      // No possible evidence, return now to prevent zero divison.
      return []
    }

    // Calculate probabilities
    for (let i = 0; i < evidence.length; i++) {
      const count = evidenceCount[i]

      if (count > 0) {
        probabilities[evidence[i]] = count / totalCount
      }
    }

    return evidenceCount
      .map((count, index) => ({
        evidence: evidence[index],
        probability: count / totalCount * 100
      }))
      .filter(x => x.probability > 0)
      .sort((a, b) => b.probability - a.probability)
  }
}
